import { BarChart } from "@mui/x-charts";
interface chartProps {
  isLoading: boolean;
  dataSet: any[];
}
export const AppBarChart: React.FunctionComponent<chartProps> = ({
  isLoading,
  dataSet,
}) => {
  const tooltipFormatter = (value: string) => {
    const item = dataSet.find((data) => data.model === value);
    return item ? (
      <>
        Model: {item.model} <br />
        Title: {item.title}
      </>
    ) : null;
  };
  return (
    <BarChart
      loading={isLoading}
      dataset={dataSet}
      xAxis={[
        {
          scaleType: "band",
          dataKey: "model",
          label: "Models",
          valueFormatter: (value, context) =>
            context.location === "tooltip" ? tooltipFormatter(value) : value,
        },
      ]}
      series={[
        {
          dataKey: "totalQuantity",
        },
      ]}
      height={300}
    />
  );
};
